import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Typography, FlexBox } from "../content";
import AlertCard from "./AlertCard.vue";

/**
 * Opens the SAFA WIKI docs.
 */

/**
 * An alert that details the required format of upload files.
 */
const __default__ = {
  name: "FileFormatAlert",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

function handleOpenWiki() {
  window.open(
    "https://www.notion.so/nd-safa/Project-Creation-5ececa9fd233437ebb37ddf893d394df#6532e1d3f983453898a8bf6ffda007f4"
  );
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(AlertCard, null, {
    default: _withCtx(() => [
      _createVNode(_unref(FlexBox), { align: "center" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Typography), {
            color: "primary",
            value: "The format of files can be found here:"
          }),
          _createVNode(_component_q_btn, {
            flat: "",
            color: "primary",
            onClick: handleOpenWiki
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Typography), { value: "SAFA WIKI" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})